import { FormattedMessage } from "react-intl";
import CopyIcon from "../../../components/Common/SvgIcons/TableIcons/CopyIcon";
import DeleteIcon from "../../../components/Common/SvgIcons/TableIcons/DeleteIcon";
// import DownloadIcon from "../../../components/Common/SvgIcons/TableIcons/DownloadIcon";
import EditIcon from "../../../components/Common/SvgIcons/TableIcons/EditIcon";
import Tooltip from "../../../components/Common/ToolTip/Tooltip";
import { tableColumnTypes } from "../../tableColumnTypes";
import { createShotclasses } from "./createShotclasses";
import RoleMenuChek from "../../../hoc/RoleMenuCheck";
import { roleMenuList } from "../../roleMenuList";

const getClassStatusLabel = (row) => {
  if (row?.StatusText) return row.StatusText;
  const statusCode = Number(row?.Status);
  if (statusCode === 0) return "Saved";
  if (statusCode === 1) return "Published";
  if (statusCode === 5) return "Processing";
  return "";
};

const getVideoUploadStatusLabel = (row) => {
  const videoStatusCode = Number(row?.VideoUploadStatus);
  return videoStatusCode === 0
    ? "Not Available"
    : videoStatusCode === 1
    ? "In Progress"
    : videoStatusCode === 2
    ? "Failed"
    : videoStatusCode === 3
    ? "Processed"
    : videoStatusCode === 4
    ? "Saved"
    : "";
};

export const myDrafts = {
  label: <FormattedMessage id="MYCLASS_DRAFTCLASSESNEW" />,
  path: (tenantName) => `/${tenantName}/manage/myDrafts`,
  searchPlaceHolder: "Search my drafts by name or tag",
  columns: (navigate, handleDeleteModal, tenantName) => [
    {
      ID: 1,
      name: <FormattedMessage id="Report_ShotClass_Name" />,
      fieldName: "Name",
      value: (row) => (
        <div title={row?.Name}>
          {row?.Name?.length > 25 ? row?.Name?.slice(0, 23) + "..." : row?.Name}
        </div>
      ),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="MYCLASS_DATEMODIFY" />,
      fieldName: "ModifiedDate",
      value: (row) => row.ModifiedDate,
      sort: true,
      type: tableColumnTypes.DATE,
    },
    {
      ID: 3,
      name: <FormattedMessage id="MyClassStatus_lbl" />,
      fieldName: "StatusText",
      value: (row) => getClassStatusLabel(row),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 4,
      name: <FormattedMessage id="MyClassVideoUploadStatus_lbl" />,
      fieldName: "VideoUploadStatusText",
      // value: (row) =>
      //   row.VideoUploadStatusText === "VideoNotAvailable"
      //     ? "Not Available"
      //     : row.VideoUploadStatusText === "ProcessingInProgress"
      //     ? "In Progress"
      //     : row.VideoUploadStatusText === "ProcessingFailed"
      //     ? "Failed"
      //     : row.VideoUploadStatusText === "ProcessingSucceed"
      //     ? "Processed"
      //     : row.VideoUploadStatusText === "Saved"
      //     ? "Saved"
      //     : "",
      value: (row) => getVideoUploadStatusLabel(row),
      sort: false,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 5,
      name: <FormattedMessage id="Cer_Actions" />,
      fieldName: "",
      value: (row) =>
        Number(row.VideoUploadStatus) !== 1 && (
          <>
            {/* <DownloadIcon /> */}
            <Tooltip
              content={<FormattedMessage id="MYCLASS_DELETE" />}
              direction={"bottom"}
            >
              <span onClick={() => handleDeleteModal(row.ID)}>
                <DeleteIcon />
              </span>
            </Tooltip>
            <RoleMenuChek
              feature={[
                {
                  roleMenu: roleMenuList?.MANAGE?.EDIT_SHOTCLASS,
                  MSOMMenu: "",
                },
              ]}
            >
              <Tooltip
                content={<FormattedMessage id="MYCLASS_EDIT" />}
                direction={"bottom"}
              >
                <span
                  onClick={() => {
                    localStorage.setItem("shotclassTypeFrom", "myDrafts");
                    navigate(
                      `${createShotclasses.editpath(tenantName)}/${row.ID}`,
                      {
                        state: { from: "myDrafts" },
                      }
                    );
                  }}
                >
                  <EditIcon />
                </span>
              </Tooltip>
              <Tooltip
                content={<FormattedMessage id="MYCLASS_COPY" />}
                direction={"bottom"}
              >
                <span
                  onClick={() => {
                    localStorage.setItem("shotclassTypeFrom", "myDrafts");
                    navigate(
                      `${createShotclasses.copypath(tenantName)}/${row.ID}`,
                      {
                        state: { from: "myDrafts" },
                      }
                    );
                  }}
                >
                  <CopyIcon />
                </span>
              </Tooltip>
            </RoleMenuChek>
          </>
        ),
      sort: false,
    },
  ],
};
